module.exports = __webpack_public_path__ + "static/img/mt1.4946ead7.jpg";